var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    attrs: {
      id: "SEO"
    }
  }, [_c("a-form-model", {
    ref: "dataForm",
    staticStyle: {
      "margin-top": "24px"
    },
    attrs: {
      model: _vm.dataForm
    }
  }, [_c("a-tabs", {
    attrs: {
      type: "card",
      activeKey: _vm.tabKey
    },
    on: {
      change: _vm.tabChange
    }
  }, [_vm._l(_vm.dataForm.SEOList, function (item, index) {
    return [_c("a-tab-pane", {
      key: item.langId,
      attrs: {
        tab: item.langName
      }
    }, [_c("a-card", {
      staticStyle: {
        width: "1184px"
      },
      attrs: {
        bordered: false
      }
    }, [[_vm.specFlag !== 2 ? _c("h3", {
      staticClass: "left24"
    }, [_vm._v(_vm._s(_vm.$t("public.public")))]) : _vm._e(), _c("a-row", {
      staticClass: "form-row",
      attrs: {
        gutter: 128
      }
    }, [_c("a-col", {
      attrs: {
        span: 16
      }
    }, [_c("a-form-model-item", {
      staticClass: "left24",
      attrs: {
        label: "SEO Title"
      }
    }, [_c("a-input", {
      attrs: {
        allowClear: "",
        placeholder: _vm.$t("public.enterPlease"),
        maxLength: 255
      },
      model: {
        value: item.title,
        callback: function callback($$v) {
          _vm.$set(item, "title", $$v);
        },
        expression: "item.title"
      }
    })], 1)], 1)], 1), _c("a-row", {
      staticClass: "form-row",
      attrs: {
        gutter: 128
      }
    }, [_c("a-col", {
      attrs: {
        span: 16
      }
    }, [_c("a-form-model-item", {
      staticClass: "left24",
      attrs: {
        label: "SEO Keywords"
      }
    }, [_c("a-input", {
      attrs: {
        allowClear: "",
        placeholder: _vm.$t("public.enterPlease"),
        maxLength: 255
      },
      model: {
        value: item.keyword,
        callback: function callback($$v) {
          _vm.$set(item, "keyword", $$v);
        },
        expression: "item.keyword"
      }
    })], 1)], 1)], 1), _c("a-row", {
      staticClass: "form-row",
      attrs: {
        gutter: 128
      }
    }, [_c("a-col", {
      attrs: {
        span: 16
      }
    }, [_c("a-form-model-item", {
      staticClass: "left24",
      attrs: {
        label: "SEO Desc"
      }
    }, [_c("a-textarea", {
      attrs: {
        rows: 3,
        maxLength: 255,
        allowClear: "",
        placeholder: _vm.$t("public.enterPlease")
      },
      model: {
        value: item.desc,
        callback: function callback($$v) {
          _vm.$set(item, "desc", $$v);
        },
        expression: "item.desc"
      }
    })], 1)], 1)], 1), _c("a-divider"), _vm._l(item.speclist, function (item2, index2) {
      return [_c("h3", {
        key: "h3" + index2,
        staticClass: "left24"
      }, [_vm._v(_vm._s(item2.specvalue))]), _c("a-row", {
        key: "row" + index2,
        staticClass: "form-row",
        attrs: {
          gutter: 128
        }
      }, [_c("a-col", {
        attrs: {
          span: 16
        }
      }, [_c("a-form-model-item", {
        staticClass: "left24",
        attrs: {
          label: "SEO Keywords"
        }
      }, [_c("a-input", {
        attrs: {
          allowClear: "",
          placeholder: _vm.$t("public.enterPlease"),
          maxLength: 255
        },
        model: {
          value: item2.keyword,
          callback: function callback($$v) {
            _vm.$set(item2, "keyword", $$v);
          },
          expression: "item2.keyword"
        }
      })], 1)], 1)], 1), index2 !== item.speclist.length - 1 ? _c("a-divider", {
        key: index2
      }) : _vm._e()];
    })]], 2)], 1)];
  })], 2), _c("footer-tool-bar", [_c("a-button", {
    attrs: {
      loading: _vm.queryLoading,
      type: "primary"
    },
    on: {
      click: _vm.saveData
    }
  }, [_vm._v(_vm._s(_vm.$t("public.save")) + " ")])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };